import React from "react";
const AppDataContext = React.createContext(null)
export default AppDataContext